import { render } from "./ApprovalsListCardHistoryApprovals.vue?vue&type=template&id=129a2f32"
import script from "./ApprovalsListCardHistoryApprovals.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardHistoryApprovals.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__